import { render, staticRenderFns } from "./InsurancesForm.vue?vue&type=template&id=e6c30b56"
import script from "./InsurancesForm.vue?vue&type=script&lang=ts"
export * from "./InsurancesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports